// personal channel response with type === 'qa'.
export const TYPE_TO_DETERMINE_PERSONAL_CHANNEL = 'qa';



// WEBPACK FOOTER //
// ./src/constants/pubnubChannel.js